import { BrowserRouter as Router, useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { AppProvider } from "./context/AppContext";
import AppRoutes from "./routes";
import "react-toastify/dist/ReactToastify.css";
import "./global.css";
import { AdminLoadingProvider } from "./context/AdminLoadingContext";
import { useEffect } from "react";

export default function App() {

  const navigate = useNavigate();

  useEffect(() => {
    const handler = () => {
      navigate("/", { replace: true });
    };

    window.addEventListener("unauthorized", handler);
    return () => window.removeEventListener("unauthorized", handler);
  }, []);

  return (
    <AppProvider>
      <AdminLoadingProvider>
        <div className="h-screen">
          <AppRoutes />
          <ToastContainer
            position="top-right"
            autoClose={3500}
            limit={3}
            closeButton={false}
            newestOnTop
            closeOnClick
            rtl
            pauseOnHover
          />
        </div>
      </AdminLoadingProvider>
    </AppProvider>
  );
};